// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1E2zJ","dragIcon":"Choice_dragIcon__2qkWF","left":"Choice_left__2Z5GI","input":"Choice_input__abyi1"};